// src/utils/fieldTranslator.js

export const FIELD_TRANSLATIONS = {
  // 求人票関連
  'pr': 'PRポイント',
  'role': '職種・ポジション', 
  'salary': '給与・年収',
  'skills': '必要スキル・経験',
  'welfare': '福利厚生',
  'location': '勤務地',
  'publishEnd': '掲載終了日',
  'publishStart': '掲載開始日',
  'pastExamples': '過去の事例',
  
  // 採用計画関連
  'difficulty': '採用難易度',
  'overview': '採用計画概要',
  'recommendedHires': '推奨採用人数',
  'requiredApplicants': '必要応募者数',
  'recruitsPeriod': '採用期間',
  'budgetDistribution': '予算配分',
  'recommendedSkills': '推奨スキル',
  'timeline': 'スケジュール',
  'advices': 'アドバイス',
  'updatedRequirements': '更新された要件',
  
  // 採用要件関連
  'startDate': '採用開始日',
  'endDate': '採用終了日',
  'budget': '予算',
  'targetHires': '希望人数',
  'position': '募集職種',
  'desiredSkillLevel': '想定スキルレベル',
  'orgIssues': '組織の課題・採用背景',
  'prioritySchedule': '優先スケジュール',
  
  // 媒体選定関連
  'planA': 'プランA',
  'planB': 'プランB', 
  'recommendation': '推奨案',
  'reason': '理由',
  'merits': 'メリット',
  'demerits': 'デメリット',
  'gptAdvice': 'AI提案',
  'mediaResult': '媒体選定結果',
  'formValues': '入力内容',
  
  // 面接サポート関連
  'strengthsAnalysis': '強み分析',
  'weaknessesAnalysis': '弱み分析',
  'culturalFit': '組織適合性',
  'recommendationLevel': '採用推薦度',
  'expectedSalary': '希望年収',
  'availableStartDate': '入社可能時期',
  'overallAssessment': '総合評価',
  'questionList': '質問リスト',
  'evaluationMapping': '評価項目質問マッピング',
  'skillCompatibility': 'スキル適合度',
  'personalityAssessment': '人物評価',
  'communicationSkills': 'コミュニケーションスキル',
  
  // 会社情報関連
  'companyName': '会社名',
  'companyScale': '会社規模', 
  'industry': '業界',
  'businessContent': '事業内容',
  'companyCatch': '会社キャッチコピー'
};

export const translateFieldNames = (text) => {
  let translatedText = text;
  
  // 英語フィールド名を日本語に変換
  Object.entries(FIELD_TRANSLATIONS).forEach(([english, japanese]) => {
    // 1. 単語境界を考慮した置換
    const regex = new RegExp(`\\b${english}\\b`, 'g');
    translatedText = translatedText.replace(regex, japanese);
    
    // 2. 括弧内での列挙（例: (pr, role, salary)）
    const parenRegex = new RegExp(`\\(([^)]*\\b${english}\\b[^)]*)\\)`, 'g');
    translatedText = translatedText.replace(parenRegex, (match, content) => {
      return `（${content.replace(new RegExp(`\\b${english}\\b`, 'g'), japanese)}）`;
    });
    
    // 3. カンマ区切りでの表現
    const commaPatterns = [
      { from: new RegExp(`\\(${english},`, 'g'), to: `（${japanese}、` },
      { from: new RegExp(`, ${english},`, 'g'), to: `、${japanese}、` },
      { from: new RegExp(`, ${english}\\)`, 'g'), to: `、${japanese}）` },
      { from: new RegExp(`${english},`, 'g'), to: `${japanese}、` },
      { from: new RegExp(`,\\s*${english}`, 'g'), to: `、${japanese}` }
    ];
    
    commaPatterns.forEach(pattern => {
      translatedText = translatedText.replace(pattern.from, pattern.to);
    });
    
    // 4. JSON形式での表現（例: "pr": 値）
    const jsonRegex = new RegExp(`"${english}"\\s*:`, 'g');
    translatedText = translatedText.replace(jsonRegex, `"${japanese}":`);
    
    // 5. テキスト中での説明（例: prは〜、roleは〜）
    const explanationRegex = new RegExp(`${english}は`, 'g');
    translatedText = translatedText.replace(explanationRegex, `${japanese}は`);
    
    const explanationRegex2 = new RegExp(`${english}が`, 'g');
    translatedText = translatedText.replace(explanationRegex2, `${japanese}が`);
    
    const explanationRegex3 = new RegExp(`${english}を`, 'g');
    translatedText = translatedText.replace(explanationRegex3, `${japanese}を`);
  });
  
  return translatedText;
};

// 特定の機能向けの専用翻訳関数
export const translateJobPostFields = (text) => {
  const jobPostFields = ['pr', 'role', 'salary', 'skills', 'welfare', 'location', 'publishEnd', 'publishStart', 'pastExamples'];
  return translateSpecificFields(text, jobPostFields);
};

export const translateRecruitPlanFields = (text) => {
  const recruitFields = ['difficulty', 'overview', 'recommendedHires', 'requiredApplicants', 'recruitsPeriod', 'budgetDistribution', 'recommendedSkills', 'timeline', 'advices'];
  return translateSpecificFields(text, recruitFields);
};

export const translateMediaSelectionFields = (text) => {
  const mediaFields = ['planA', 'planB', 'recommendation', 'reason', 'merits', 'demerits', 'gptAdvice', 'mediaResult'];
  return translateSpecificFields(text, mediaFields);
};

export const translateInterviewFields = (text) => {
  const interviewFields = ['strengthsAnalysis', 'weaknessesAnalysis', 'culturalFit', 'recommendationLevel', 'expectedSalary', 'availableStartDate', 'overallAssessment', 'questionList'];
  return translateSpecificFields(text, interviewFields);
};

const translateSpecificFields = (text, fieldList) => {
  let translatedText = text;
  fieldList.forEach(field => {
    if (FIELD_TRANSLATIONS[field]) {
      const regex = new RegExp(`\\b${field}\\b`, 'g');
      translatedText = translatedText.replace(regex, FIELD_TRANSLATIONS[field]);
    }
  });
  return translatedText;
};